import { sendRequest } from './index';
import { API_COMPETENCY_URL } from '@core/constants/API';

export const userSkillOverview = {
    GET: () =>
        sendRequest({
            url: `${API_COMPETENCY_URL}skill-overview`,
            method: 'GET'
        }),
};

export const competencyMarketRadar = {
    GET: (queryparams) =>
        sendRequest({
            url: `${API_COMPETENCY_URL}market-radar${queryparams}`,
            method: 'GET'
        }),
};